// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-widget-parent-container.active-edit:hover{
    box-shadow: 0px 0px 20px rgba(187, 187, 187, 0.199);
}
.general-widget-parent-container.passive-edit:hover{
    box-shadow: 0px 0px 12px rgba(44, 44, 44, 0.4);
}
.general-widget-parent-container.selected-edit{
    box-shadow: 0px 0px 16px rgba(11, 141, 228, 0.5);
}
.general-widget-parent-container.active-edit > *{
    pointer-events: none;
}
.general-widget-active-edit-mask.active{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.658);
    z-index: 1;
}
.general-widget-container{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: white;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
}
.general-widget-container.inactive > *{
    pointer-events: none;
}
.general-widget-parent-container.passive-edit:hover .general-widget-edit-controls-container{
    visibility: visible;
}
.general-widget-parent-container.passive-edit .general-widget-edit-controls-container{
    visibility: hidden;
}
.general-widget-edit-controls-container{
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    padding: 4px 2px;
    pointer-events: auto;
    background-color: white;
    transform: translateY(-100%);
    box-shadow: 0px 0px 2px rgba(49, 49, 49, 0.4);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.general-widget-edit-controls-container div{
    cursor: pointer;
}
.general-widget-edit-controls-container p{
    margin: 0px 6px;
}
.general-widget-edit-controls-container .edit-widget-p::after{
    content: 'Edit widget';
    position: absolute;
    top: -100%;
    right: 40%;
    transform: translateY(-2px);
    color: white;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    background-color: rgb(96, 96, 96);
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;
}
.general-widget-edit-controls-container .edit-widget-p:hover::after{
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transition-delay: 0.2s;
}
.general-widget-edit-controls-container .export-widget-p::after{
    content: 'Export widget';
    position: absolute;
    top: -100%;
    right: 0;
    transform: translateY(-2px);
    color: white;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    background-color: rgb(96, 96, 96);
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;
}
.general-widget-edit-controls-container .export-widget-p:hover::after{
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transition-delay: 0.2s;
}
.general-widget-edit-controls-container .remove-widget-p::after{
    content: 'Remove widget';
    position: absolute;
    top: -100%;
    right: -20%;
    transform: translateY(-2px);
    color: white;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    background-color: rgb(96, 96, 96);
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;
}
.general-widget-edit-controls-container .remove-widget-p:hover::after{
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transition-delay: 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/GeneralWidget.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;AACvD;AACA;IACI,8CAA8C;AAClD;AACA;IACI,gDAAgD;AACpD;AACA;IACI,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,4CAA4C;IAC5C,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,4BAA4B;IAC5B,6CAA6C;IAC7C,4DAA4D;AAChE;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,iEAAiE;AACrE;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,iEAAiE;AACrE;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,iEAAiE;AACrE;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".general-widget-parent-container.active-edit:hover{\r\n    box-shadow: 0px 0px 20px rgba(187, 187, 187, 0.199);\r\n}\r\n.general-widget-parent-container.passive-edit:hover{\r\n    box-shadow: 0px 0px 12px rgba(44, 44, 44, 0.4);\r\n}\r\n.general-widget-parent-container.selected-edit{\r\n    box-shadow: 0px 0px 16px rgba(11, 141, 228, 0.5);\r\n}\r\n.general-widget-parent-container.active-edit > *{\r\n    pointer-events: none;\r\n}\r\n.general-widget-active-edit-mask.active{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(255, 255, 255, 0.658);\r\n    z-index: 1;\r\n}\r\n.general-widget-container{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n.general-widget-container.inactive > *{\r\n    pointer-events: none;\r\n}\r\n.general-widget-parent-container.passive-edit:hover .general-widget-edit-controls-container{\r\n    visibility: visible;\r\n}\r\n.general-widget-parent-container.passive-edit .general-widget-edit-controls-container{\r\n    visibility: hidden;\r\n}\r\n.general-widget-edit-controls-container{\r\n    position: absolute;\r\n    z-index: 2;\r\n    right: 0;\r\n    top: 0;\r\n    padding: 4px 2px;\r\n    pointer-events: auto;\r\n    background-color: white;\r\n    transform: translateY(-100%);\r\n    box-shadow: 0px 0px 2px rgba(49, 49, 49, 0.4);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.general-widget-edit-controls-container div{\r\n    cursor: pointer;\r\n}\r\n.general-widget-edit-controls-container p{\r\n    margin: 0px 6px;\r\n}\r\n.general-widget-edit-controls-container .edit-widget-p::after{\r\n    content: 'Edit widget';\r\n    position: absolute;\r\n    top: -100%;\r\n    right: 40%;\r\n    transform: translateY(-2px);\r\n    color: white;\r\n    padding: 6px 8px;\r\n    font-size: 12px;\r\n    border-radius: 4px;\r\n    white-space: nowrap;\r\n    background-color: rgb(96, 96, 96);\r\n    pointer-events: none;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;\r\n}\r\n.general-widget-edit-controls-container .edit-widget-p:hover::after{\r\n    opacity: 1;\r\n    visibility: visible;\r\n    pointer-events: all;\r\n    transition-delay: 0.2s;\r\n}\r\n.general-widget-edit-controls-container .export-widget-p::after{\r\n    content: 'Export widget';\r\n    position: absolute;\r\n    top: -100%;\r\n    right: 0;\r\n    transform: translateY(-2px);\r\n    color: white;\r\n    padding: 6px 8px;\r\n    font-size: 12px;\r\n    border-radius: 4px;\r\n    white-space: nowrap;\r\n    background-color: rgb(96, 96, 96);\r\n    pointer-events: none;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;\r\n}\r\n.general-widget-edit-controls-container .export-widget-p:hover::after{\r\n    opacity: 1;\r\n    visibility: visible;\r\n    pointer-events: all;\r\n    transition-delay: 0.2s;\r\n}\r\n.general-widget-edit-controls-container .remove-widget-p::after{\r\n    content: 'Remove widget';\r\n    position: absolute;\r\n    top: -100%;\r\n    right: -20%;\r\n    transform: translateY(-2px);\r\n    color: white;\r\n    padding: 6px 8px;\r\n    font-size: 12px;\r\n    border-radius: 4px;\r\n    white-space: nowrap;\r\n    background-color: rgb(96, 96, 96);\r\n    pointer-events: none;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: opacity 0.8s ease-in-out, visibility 0.8s linear 0.8s;\r\n}\r\n.general-widget-edit-controls-container .remove-widget-p:hover::after{\r\n    opacity: 1;\r\n    visibility: visible;\r\n    pointer-events: all;\r\n    transition-delay: 0.2s;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
